<template>
  <v-container>
    <v-card color="#BBDEFB">
      <v-card-title>{{ displayName }} さんの完登状況</v-card-title>
      <v-spacer></v-spacer>
      <p class="text-center text-h3">{{ current }} / {{ max }}({{ rate }}%)</p>
      <v-progress-linear
        color="light-blue"
        height="40"
        :value="rate"
        striped
      ></v-progress-linear>
    </v-card>
    <v-spacer></v-spacer>
    <DataTable
      :tableTitle="tableTitle"
      :headers="headers"
      :values="values"
      :sortby="sortby"
      :sortdesc="sortdesc"
      :noDataText="noDataText"
      :loading="isDataLoad"
      dense
    ></DataTable>
  </v-container>
</template>
<script>
/* eslint-disable no-console */
import moment from "moment";
import stores from "../../stores";
import { db } from "../../plugins/firebase";
import DataTable from "@/components/Table/DataTable.vue";
export default {
  name: "ascend",
  components: {
    DataTable,
  },
  mounted() {
    this.checkState();
  },
  watch: {
    values() {
      this.current = this.values.length;
      this.calc();
    },
  },
  data() {
    return {
      sharedState: stores.state,
      current: 0,
      max: 0,
      rate: 0,
      displayName: "名無し",
      problems: [],
      values: [],
      tableTitle: "完登リスト",
      headers: [
        { text: "投稿日", value: "create_at" },
        { text: "傾斜", value: "wall.angle" },
        { text: "グレード", value: "grade.grade" },
        { text: "課題名", value: "problem" },
        { text: "作成者", value: "user" },
        { text: "Love!", value: "good" },
        { text: "登れた！", value: "ascent" },
        { text: "タグ", value: "tag" },
        { text: "アクション", value: "action" },
      ],
      sortby: ["create_at", "wall"],
      sortdesc: [true, true],
      noDataText: "完登済みの課題はまだありません",
      isDataLoad: true,
    };
  },
  methods: {
    calc() {
      this.rate = Math.ceil((this.current / this.max) * 100);
    },
    /**
     * 完登済み課題を取得する
     */
    async getAscendProblem(userRef) {
      var first = true;
      db.collection("T_PROBLEM")
        .where("ascent", "array-contains-any", [userRef])
        .onSnapshot((snapShot) => {
          // 初回読み込みなら
          if (first) {
            this.current = snapShot.docs.length;
            if (snapShot.empty) return;
            snapShot.docs.forEach(async (n) => {
              const data = n.data();
              const timestamp = moment(data.create_at.toDate());
              data.create_at = timestamp.format("YYYY-MM-DD");
              const user = await data.user.get();
              data.user = user.data().displayName;
              const photo = await data.photo.get();
              data.photo = [photo.data()];
              data.id = n.id;
              if (data.open) {
                this.values.push(data);
              }
            });
            first = false;
            // リアルタイムアップデートなら
          } else {
            // 今の所処理なし
          }
        });
      this.isDataLoad = false;
    },
    async checkState() {
      await stores.setUserAuth();
      if (this.sharedState.user.isLogin) {
        this.displayName = this.sharedState.user.displayName;
        await this.getAscendProblem(this.sharedState.user.ref);
        const result = await db
          .collection("M_GYM")
          .doc(this.sharedState.user.gymid)
          .get();
        const gym = result.data();
        this.max = gym.problem_num;
      } else {
        this.$router.push("/signin");
      }
    },
  },
};
</script>
